module.exports = __webpack_public_path__ + "img/risk-moderate.cd4fd126.png";